(() => {
  function init(){document.querySelectorAll('[data-ns-ticker]').forEach(ticker=>{
    if(ticker.dataset.ready)return;ticker.dataset.ready='true';
    if(ticker.dataset.enabled!=='true')return;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)'),button=ticker.querySelector('[data-ns-ticker-pause]');
    const group=ticker.querySelector('.ns-ticker__group'),copy=ticker.querySelector('.ns-ticker__copy');
    function fill(){
      group.querySelectorAll('[data-ns-fill]').forEach(x=>x.remove());
      if(!reduced.matches){const originals=[...group.children];let rounds=0;while(originals.length&&group.getBoundingClientRect().width<ticker.querySelector('.ns-ticker__viewport').clientWidth&&rounds++<40){originals.forEach(item=>{const extra=item.cloneNode(true);extra.dataset.nsFill='true';extra.setAttribute('aria-hidden','true');extra.setAttribute('inert','');group.append(extra);});}}
      copy.innerHTML=group.innerHTML;
    }
    function mode(){ticker.classList.toggle('is-moving',!reduced.matches);button.hidden=reduced.matches;fill();}
    new ResizeObserver(()=>{if(ticker.isConnected)fill();}).observe(ticker.querySelector('.ns-ticker__viewport'));
    button.addEventListener('click',()=>{const paused=ticker.classList.toggle('is-paused');button.textContent=paused?'Play':'Pause';button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',`${paused?'Play':'Pause'} ${ticker.getAttribute('aria-label')}`);});
    reduced.addEventListener('change',mode);mode();
  });}
  init();document.addEventListener('shopify:section:load',init);
})();
